export const EVIDENCE_TAB_SLUGS = {
  OVERVIEW: "overview",
  COC: "coc",
  ACQUISITIONS: "acquisitions",
  CHILD_ITEMS: "child-items",
  PHOTOS: "photos",
  FILES: "files",
  AUDIT: "audit",
} as const;

export type EvidenceTabSlug =
  typeof EVIDENCE_TAB_SLUGS[keyof typeof EVIDENCE_TAB_SLUGS];
